import { Conveyor} from './conveyor';
import {ModuleConnections} from './enums/module-connections.enum';


export class Connections {
  constructor(public moduleConnection: ModuleConnections, public conveyor: Conveyor) {

  }
}
